import { h, render } from 'preact';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Container.
import App from './containers/App';

// Utilities
import { getPackageData } from './utilities/api/package';
import { requestCredentials } from './utilities/api/auth';
import { createEvent, createFlowEvent } from './utilities/common';
// import registerServiceWorker from './utilities/registerServiceWorker';

// Importing Styles
import './assets/styles/critical.scss';
import './assets/styles/main.scss';

// Actions
import { appLoading, appInitial } from './actions/App';

// Configuring Redux Store
import { store, persistor } from './utilities/configureStore';

const beforeLift = () => {
  const initialize = (event) => {
    store.dispatch(appInitial(event.detail || {}));
    // Get package data.
    store.dispatch(getPackageData()).then(() =>
      store.dispatch(requestCredentials()).then(() =>
        store.dispatch(appLoading(false)))
    );
    window.removeEventListener('flow-notify-default', initialize);
  };

  window.addEventListener('flow-notify-default', initialize);
};

const root = document.getElementById('root');

render(
  <Provider store={store}>
    <PersistGate
      onBeforeLift={beforeLift()}
      persistor={persistor}
    >
      <App/>
    </PersistGate>
  </Provider>,
  root
);

if (root.getAttribute('data-notify') !== 'true') {
  createEvent('flow-notify-default');
} else {
  createFlowEvent('loaded');
}

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js